import { FC, memo } from 'react';

import AcceptConflict from '@/assets/icons/AcceptConflict';
import DefectNietInzetbaar from '@/assets/icons/DefectNietInzetbaar';
import Edit from '@/assets/icons/Edit';
import Scissor from '@/assets/icons/Scissor';
import Trash from '@/assets/icons/Trash';
import Versterken from '@/assets/icons/Versterken';
import Verzwakken from '@/assets/icons/Verzwakken';
import Werklijndiagram from '@/assets/icons/Werklijndiagram';
import { MwdContextMenuInformation } from '@/components/contextMenu/mwdContextMenu/types';

import useMwdActions from '../../hooks/useMwdActions';

import ActionLink from './ActionLink';
import ExecuteActionLink from './ExecuteActionLink';

const Li = ActionLink;

type ContextMenuDeeltrajectProps = {
  contextData: MwdContextMenuInformation;
  noSelectedDeeltrajecten: number;
  isAllowedToMutate: boolean;
  isAllowedToInregelingen: boolean;
  isAllowedToDefecten: boolean;
  isMultiSelect: boolean;
  isClaim: boolean;
  isContextMenu: boolean;
  isManco: boolean;
  isVerkeerdMat: boolean;
};
const ContextMenuDeeltraject: FC<ContextMenuDeeltrajectProps> = ({
  contextData,
  isAllowedToMutate,
  isAllowedToDefecten,
  isAllowedToInregelingen,
  isMultiSelect,
  isClaim,
  isContextMenu,
  isManco,
  isVerkeerdMat,
  noSelectedDeeltrajecten,
}) => {
  const { toonGekoppeldeWerklijnen } = useMwdActions();
  return (
    <>
      {isMultiSelect && isAllowedToMutate ? (
        <>
          <Li actionKey='multi-versterken' icon={Versterken}>
            Versterk {noSelectedDeeltrajecten} inzetten…
          </Li>
          <Li actionKey='multi-verzwakken' icon={Verzwakken}>
            Verzwak {noSelectedDeeltrajecten} inzetten…
          </Li>
        </>
      ) : (
        <>
          {Boolean(isClaim && isAllowedToMutate) && (
            <>
              <Li actionKey='claim-wijzigen' icon={Edit}>
                Wijzig claim…
              </Li>
              <Li actionKey='verwijder-claim' icon={Trash}>
                Verwijder claim
              </Li>
            </>
          )}
          {!isClaim && (
            <>
              {isContextMenu && (
                <ExecuteActionLink
                  actionKey='gekoppelde-werklijnen'
                  icon={Werklijndiagram}
                  action={toonGekoppeldeWerklijnen(contextData?.details)}
                  shortcut='Alt+T'
                >
                  Toon gekoppelde werklijn(en)
                </ExecuteActionLink>
              )}
              {isAllowedToMutate && (
                <>
                  <Li actionKey='inzet-versterken' icon={Versterken} shortcut='Alt+V'>
                    Versterk inzet…
                  </Li>
                  <Li actionKey='inzet-wijzigen' icon={Edit}>
                    Wijzig inzet…
                  </Li>
                  <Li actionKey='knippen' icon={Scissor} shortcut='Alt+K'>
                    Knip inzet…
                  </Li>
                  <Li actionKey='inzet-verzwakken' icon={Verzwakken} shortcut='Delete'>
                    Verzwak inzet…
                  </Li>
                </>
              )}

              {isAllowedToDefecten && !isManco && (
                <Li actionKey='niet-inzetbaar-vanaf' icon={DefectNietInzetbaar}>
                  {isContextMenu ? 'Meld defect…' : 'Defect melden…'}
                </Li>
              )}
            </>
          )}
        </>
      )}
      {isAllowedToInregelingen && (isManco || isVerkeerdMat) && (
        <Li actionKey='accepteer-conflict' icon={AcceptConflict}>
          Accepteer conflict...
        </Li>
      )}
    </>
  );
};

export default memo(ContextMenuDeeltraject);
